import EventsCovered from "components/EventsCovered/EventsCovered";
import SectionHero from "containers/PageAbout/SectionHero2";
import rightImg from "images/herosectionabout.png";

function Events() {
  return (
    <div>
      {" "}
      <div className="container pt-16 ">
        <SectionHero
          rightImg={rightImg}
          heading="Unforgettable Events, Exceptional Experiences"
          btnText=""
          subHeading="Host your next special occasion in a stunning setting designed for unforgettable moments. Whether you're planning a romantic wedding, an exciting bachelorette party, an immersive wine tour, a vibrant quinceañera, or a lively concert, we offer the perfect space and services to bring your vision to life. Let us take care of the details while you celebrate in style."
        />
      </div>
      <div className="container  ">
        <EventsCovered />
      </div>
    </div>
  );
}

export default Events;
